// pages/BatchReports/BatchReportsPage.js
import React, { useEffect, useMemo, useState } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import PageTitle from "components/PageTitle/PageTitle";
import useStyles from "./styles";
import BatchReportsTable from "components/MUIDatatable/BatchReportsTable";
import BatchReportSubmitSection from "components/BatchReports/BatchReportSubmitSection";
import { dbGet } from "utils/DBFetchers";

const MANIFEST_ENDPOINT = "cli/batch/report_manifest";

function buildEndpointWithParams(endpoint, paramsObj = {}) {
  const params = new URLSearchParams();

  Object.entries(paramsObj).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, String(value));
    }
  });

  const query = params.toString();
  return query ? `${endpoint}?${query}` : endpoint;
}

export default function BatchReportsPage({
  title = "Tareas",
  releasedForOperator = false,
}) {
  const classes = useStyles();

  const [tasksByKey, setTasksByKey] = useState({});
  const [manifestEtag, setManifestEtag] = useState(null);
  const [manifestLoading, setManifestLoading] = useState(false);
  const [manifestError, setManifestError] = useState(null);
  const releasedQueryParams = useMemo(
    () => ({
      released_for_operator: releasedForOperator ? true : undefined,
    }),
    [releasedForOperator]
  );

  useEffect(() => {
    let active = true;

    const fetchManifest = async () => {
      setManifestLoading(true);
      setManifestError(null);

      try {
        // Backend: GET /cli/batch/report_manifest
        const resp = await dbGet(
          buildEndpointWithParams(MANIFEST_ENDPOINT, releasedQueryParams)
        );

        const reportManifestJson = resp?.report_manifest_json || resp?.data?.report_manifest_json;
        const etag = resp?.etag || resp?.data?.etag;

        if (!reportManifestJson || typeof reportManifestJson !== "object") {
          throw new Error("Manifest inválido: no llegó report_manifest_json como objeto.");
        }

        if (active) {
          setTasksByKey(reportManifestJson);
          setManifestEtag(etag || null);
        }
      } catch (err) {
        if (active) {
          setManifestError("Error al cargar el manifest de reportes.");
        }
      } finally {
        if (active) setManifestLoading(false);
      }
    };

    fetchManifest();

    return () => {
      active = false;
    };
  }, [releasedQueryParams]);

  return (
    <Grid>
      <PageTitle title={title} />

      <Paper elevation={3} className={classes.paperContainer}>
        <Grid container direction="column" spacing={3} style={{ padding: 16, background: "#f5f5f5" }}>
          <Grid item xs={12} style={{ marginTop: 16, overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
            <BatchReportsTable queryParams={releasedQueryParams} />
          </Grid>

          {/* Estado de carga del manifest */}
          <Grid item>
            {manifestLoading ? (
              <Typography color="textSecondary">Cargando manifest...</Typography>
            ) : null}

            {manifestError ? (
              <Typography color="error">{manifestError}</Typography>
            ) : null}

            {!manifestLoading && !manifestError && manifestEtag ? (
              <Typography variant="caption" color="textSecondary">
                Manifest ETag: {manifestEtag}
              </Typography>
            ) : null}
          </Grid>

          {/* Sección submit separada */}
          {!manifestLoading && !manifestError ? (
            <Grid item>
              <BatchReportSubmitSection tasksByKey={tasksByKey} />
            </Grid>
          ) : null}
        </Grid>
      </Paper>
    </Grid>
  );
}
